import React, { useCallback, useState } from 'react';
import { PapiAttachmentFile, PapiDeviation } from '@wix/da-papi-types';
import { Props as PreviewThumbProps } from '../PreviewThumb';
import ImageAttachmentThumb from './ImageAttachmentThumb';

interface Props extends PreviewThumbProps {
  deviation?: PapiDeviation;
  attachment: PapiAttachmentFile;
  removeAttachment?: (fileId: number, callback?: () => void) => void;
}

const AttachmentThumb: React.FC<Props> = ({
  attachment,
  deviation,
  selected,
  removeAttachment,
  ...props
}) => {
  const [isRemoved, setIsRemoved] = useState(false);

  const onRemove = useCallback(
    e => {
      e.stopPropagation();
      if (attachment && attachment.fileId) {
        if (deviation) {
          removeAttachment?.(attachment.fileId, () => setIsRemoved(true));
        }
      }
    },
    [removeAttachment, deviation, attachment]
  );

  return (
    <ImageAttachmentThumb
      {...props}
      attachment={attachment}
      deviation={deviation}
      isRemoved={isRemoved}
      selected={selected}
      onRemove={onRemove}
    />
  );
};

AttachmentThumb.displayName = 'AttachmentThumb';

export default AttachmentThumb;
